import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@jti/fe-common";
import { Box } from "@jti/ui";
const OrderDotContent = ({ condition, children, title, className }) => {
    const Content = () => {
        if (!condition) {
            return _jsx(_Fragment, { children: "..." });
        }
        return _jsx(_Fragment, { children: children });
    };
    return (_jsx(Box, { className: className, title: __(title), accent: true, children: _jsx(Content, {}) }));
};
export default OrderDotContent;
//# sourceMappingURL=OrderDotContent.js.map